/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AmountCell/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AmountCell({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/AmountCell"
  
}) {
let transactionValueData = fromData.useDataFormat({ viewPath,
context: 'transaction',
format: fromHelpers.getAmount,
})
  return (<React.Fragment
>
<div
  data-testid="AmountCell.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="transaction"
 format="helpers.js getAmount"
 text={transactionValueData}
/>
</div>
{children}
</React.Fragment>)
}